export default __webpack_public_path__ + "static/media/p23.960a0d85.JPG";